"use strict";

(function () {
  'use strict';

  angular.module('ga.service.analytics', []).service('AnalyticsService', AnalyticsService);
  AnalyticsService.$inject = ['$http'];

  function AnalyticsService($http) {
    this.pageView = function (page) {
      if (typeof window.ga !== 'undefined') {
        window.ga('set', 'page', page);
        window.ga('send', 'pageview');
      }

      if (typeof window.gtag !== 'undefined') {
        window.gtag('set', {
          page: page
        });
        window.gtag('event', 'page_view', {
          'page_title': page
        });
      }
    };

    this.trackEvent = function (_ref) {
      var category = _ref.category,
          action = _ref.action,
          label = _ref.label,
          value = _ref.value;

      if (typeof window.ga !== 'undefined') {
        window.ga('send', 'event', {
          eventCategory: category,
          eventAction: action,
          eventLabel: label,
          eventValue: value
        });
      }

      if (typeof window.gtag !== 'undefined') {
        window.gtag('event', action, {
          'event_category': category,
          'event_label': label,
          'value': value
        });
      }
    };

    this.timing = function (_ref2) {
      var category = _ref2.category,
          label = _ref2.label,
          value = _ref2.value;

      if (typeof window.ga !== 'undefined') {
        window.ga('send', 'timing', category, label, value);
      }

      if (typeof window.gtag !== 'undefined') {
        window.gtag('event', 'timing_complete', {
          'name': 'timing',
          'value': value,
          'event_category': category,
          'event_label': label
        });
      }
    };

    this.getGtag = function () {
      return $http({
        method: 'GET',
        url: 'admin/analytics'
      }).then(function (response) {
        return response;
      });
    };
  }
})();